import { Component, OnInit } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private privacyPolicy;
  private loading: boolean = false;
  //private killServicesOnDestroy = [];
    
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.fetchPrivacyPolicy();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Privacy Policy";
    this.commonService.header = this.headerData;  
  }

  fetchPrivacyPolicy(){
    this.loading = true;
    let privacyPolicySubscription = this.commonService.fetchPrivacyPolicy().subscribe(privacyData=>{
      this.loading = false;
      this.privacyPolicy = privacyData;
    },
    error=>{
      this.loading = false;
    });
    this.commonService.runningServices.push(privacyPolicySubscription);
  }
  ngOnDestroy() {
    this.commonService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}